import { Link } from "react-router-dom";
import { Button } from "@satyrsmc/shared/components";

interface ErrorPageProps {
  error?: Error;
}

export function ErrorPage({ error }: ErrorPageProps) {
  return (
    <main className="flex min-h-screen flex-col items-center justify-center p-4 md:p-6">
      <div className="max-w-md text-center">
        <p className="text-6xl font-bold text-muted-foreground">!</p>
        <h1 className="mt-2 text-xl font-semibold">Something went wrong</h1>
        <p className="mt-2 text-muted-foreground">
          An unexpected error occurred. Please try again.
        </p>
        {error && (
          <details className="mt-4 rounded bg-muted p-3 text-left text-sm text-muted-foreground">
            <summary className="cursor-pointer">Error details</summary>
            <pre className="mt-2 whitespace-pre-wrap break-words">{error.message}</pre>
          </details>
        )}
        <div className="mt-6 flex flex-wrap justify-center gap-3">
          <Button variant="outline" onClick={() => window.location.reload()}>
            Reload page
          </Button>
          <Button asChild>
            <Link to="/login">Back to Login</Link>
          </Button>
        </div>
      </div>
    </main>
  );
}
